import { heroStats } from "@/mocks/categories";

export default function AboutHero() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20illustration%20of%20a%20circular%20gathering%20of%20speech%20bubbles%20connected%20by%20thin%20lines%2C%20deep%20terracotta%20and%20amber%20gradient%20background%2C%20geometric%20shapes%2C%20cinematic%20soft%20light%2C%20no%20text%2C%20no%20faces&width=1600&height=760&seq=guayouhui-about-hero&orientation=landscape"
        alt="瓜友会网团队整理爆料时间线的氛围图"
        title="关于瓜友会网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/65 to-primary-900/70"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-24">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm">
          <i className="ri-user-heart-line" aria-hidden="true"></i>
          关于我们
        </span>
        <h1 className="mt-5 text-3xl md:text-5xl font-bold text-background-50 tracking-tight">
          关于瓜友会网
        </h1>
        <p className="mt-5 max-w-3xl text-sm md:text-lg text-background-100/85 leading-relaxed">
          我们是一群常年在信息流里蹲进展的普通瓜友。因为受不了"标题很炸、点开没料"，
          索性自己动手：把全网散落的线索收集起来，核对时间、标明来源、梳理顺序，
          做成一条条能看明白的记录。这就是瓜友会网的起点。
        </p>

        <dl className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-3xl">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm px-3 py-4 flex flex-col"
            >
              <dd className="order-1 text-xl md:text-2xl font-bold text-accent-300">
                {stat.value}
              </dd>
              <dt className="order-2 mt-1 text-[11px] md:text-xs text-background-100/70">
                {stat.label}
              </dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}